import { LegendOptions, Options } from 'highcharts';

import { legendOptions } from '../shared/Config';

export type BuildLegendProps = {
  legendGenerator?: (color: string, name: string) => string;
} & LegendOptions;

const defaultLegendOptions = {
  ...legendOptions,
  symbolHeight: 0,
  symbolWidth: 0,
  symbolRadius: 0,
};

const buildLegend = (props: BuildLegendProps): Options['legend'] => {
  const { legendGenerator, ...restOptions } = props;
  return {
    ...(Object.keys(restOptions).length > 0 ? restOptions : defaultLegendOptions),
    ...(legendGenerator
      ? {
          labelFormatter: function (): string {
            const { color, name } = this as unknown as any;
            return legendGenerator(color, name);
          },
        }
      : {}),
  };
};

export default buildLegend;
